module.exports = __webpack_public_path__ + "static/media/caribouwebflow.e986743c.png";